import React from 'react';
import useClipboard from 'hooks/clipboard';
import copyImg from 'assets/svg/copy.svg';
import '../assets/share-url.styles.scss';

type CopyLinkFormProps = {
    url: string,
    label?: string;
    className?: string;
    onClick?: () => void;
};

const CopyLinkForm: React.FC<CopyLinkFormProps> = ({ url, label, className, onClick }): JSX.Element => {
    const [copied, setCopied] = React.useState(false);
    const clipboardRef = useClipboard(() => setCopied(true));

    return (
        <div className={`c-partner-link-form ${className || ''}`.trim()}>
            <div className="c-partner-link-form__icon">
                <img src={copyImg} className="mb-2" role='presentation' />
                <p className="body-2 lg:body-1 medium">Copiar Link</p>
            </div>
            <form className={`c-partner-link-form__form ${copied ? 'link-copied' : ''}`.trim()}>
                <label className="caption">{label || 'Copie o link e envie para seu sócio'}</label>
                <input value={url} disabled />
                <button
                    ref={clipboardRef}
                    data-clipboard-text={url}
                    onClick={ () => {
                        if(onClick) {
                            onClick()
                        }
                    }}
                    type="button">{copied ? 'Copiado' : 'Copiar'}</button>
            </form>
        </div>
    );
};

export default CopyLinkForm;
